<template lang="es">
    <v-container fluid>
        <!-- {{this.parrilla-1}} -->
        <!-- {{data}} -->
        <v-card>
        <!-- <v-card-title>Scrollable Table</v-card-title> -->
        <v-card-text>
          <div class="table-container">
        <table>
        <thead>
            <tr>
                <th rowspan="1" colspan="2"> </th>
                <th colspan="1"  class="fixed-width">Parado</th>
                <th colspan="1"  class="fixed-width">Averia</th>
                <th colspan="1"  class="fixed-width">Tolva llena</th>
                <th colspan="1"  class="fixed-width">Consumo OK</th>
                <th colspan="1"  class="fixed-width">Consumo Alto</th>
            </tr>
            <!-- <tr>
                <th>Horas</th>
                <th>Minutos</th>
                <th>Horas</th>
                <th>Minutos</th>  
                <th>Horas</th>
                <th>Minutos</th>
                <th>Horas</th>
                <th>Minutos</th>
                <th>Horas</th>
                <th>Minutos</th>
            </tr> -->
        </thead>
        <tbody>
            <!-- <td v-for="(item, index) in 9" :key="index">{{getValue(getMemory(index))}}</td> -->
            <!-- <tr>
            
        </tr> -->
            <tr>
                <td colspan="2">Actual Turno:</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index))}}:{{getValue(getMemory(2*index+1))}}</td>
            </tr>
            <tr>
                <td rowspan="4">Lunes</td>
                <td>T1</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+10))}}:{{getValue(getMemory(2*index+11))}}</td>
            </tr>
            <tr>
                <td>T2</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+20))}}:{{getValue(getMemory(2*index+21))}}</td>           
            </tr>
            <tr>
                <td>T3</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+30))}}:{{getValue(getMemory(2*index+31))}}</td>            
            </tr>
            </tr>
            <tr>
                <td>Total</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+40))}}:{{getValue(getMemory(2*index+41))}}</td>
            </tr>
            <tr>
                <td rowspan="4">Martes</td>
                <td>T1</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+50))}}:{{getValue(getMemory(2*index+51))}}</td>
            </tr>
            <tr>
                <td>T2</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+60))}}:{{getValue(getMemory(2*index+61))}}</td>
            </tr>
            <tr>
                <td>T3</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+70))}}:{{getValue(getMemory(2*index+71))}}</td>
            </tr>
            <tr>
                <td>Total</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+80))}}:{{getValue(getMemory(2*index+81))}}</td>
            </tr>
            <tr>
                <td rowspan="4">Miércoles</td>
                <td>T1</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+90))}}:{{getValue(getMemory(2*index+91))}}</td>
            </tr>
            <tr>
                <td>T2</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+100))}}:{{getValue(getMemory(2*index+101))}}</td>
            </tr>
            <tr>
                <td>T3</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+110))}}:{{getValue(getMemory(2*index+111))}}</td>
            </tr>
            <tr>
                <td>Total</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+120))}}:{{getValue(getMemory(2*index+121))}}</td>
            </tr>
            <tr>
                <td rowspan="4">Jueves</td>
                <td>T1</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+130))}}:{{getValue(getMemory(2*index+131))}}</td>
            </tr>
            <tr>
                <td>T2</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+140))}}:{{getValue(getMemory(2*index+141))}}</td>
            </tr>
            <tr>
                <td>T3</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+150))}}:{{getValue(getMemory(2*index+151))}}</td>
            </tr>
            <tr>
                <td>Total</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+160))}}:{{getValue(getMemory(2*index+161))}}</td>
            </tr>
            <tr>
                <td rowspan="4">Viernes</td>
                <td>T1</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+170))}}:{{getValue(getMemory(2*index+171))}}</td>
            </tr>
            <tr>
                <td>T2</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+180))}}:{{getValue(getMemory(2*index+181))}}</td>
            </tr>
            <tr>
                <td>T3</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+190))}}:{{getValue(getMemory(2*index+191))}}</td>
            </tr>
            <tr>
                <td>Total</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+200))}}:{{getValue(getMemory(2*index+201))}}</td>
            </tr>
            <tr>
                <td rowspan="4">Sábado</td>
                <td>T1</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+210))}}:{{getValue(getMemory(2*index+211))}}</td>
            </tr>
            <tr>
                <td>T2</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+220))}}:{{getValue(getMemory(2*index+221))}}</td>
            </tr>
            <tr>
                <td>T3</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+230))}}:{{getValue(getMemory(2*index+231))}}</td>
            </tr>
            <tr>
                <td>Total</td>
                <td v-for="(item, index) in 5" :key="index">{{getValue(getMemory(2*index+240))}}:{{getValue(getMemory(2*index+241))}}</td>
            </tr>
            
        </tbody>
    </table>
</div>
</v-card-text>
</v-card>
    
</v-container>


</template>
<script>
export default {
    props:{
        data:Object,
        parrilla:Number
    },

    data() {
        return {
            datos_parrilla:
            [
                ['D606','D607','D616','D617','D626','D627','D636','D637','D646','D647',
'D700','D701','D710','D711','D720','D721','D730','D731','D740','D741',
'D702','D703','D712','D713','D722','D723','D732','D733','D742','D743',
'D704','D705','D714','D715','D724','D725','D734','D735','D744','D745',
'D708','D709','D718','D719','D728','D729','D738','D739','D748','D749',

'D800','D801','D810','D811','D820','D821','D830','D831','D840','D841',
'D802','D803','D812','D813','D822','D823','D832','D833','D842','D843',
'D804','D805','D814','D815','D824','D825','D834','D835','D844','D845',
'D808','D809','D818','D819','D828','D829','D838','D839','D848','D849',

'D900','D901','D910','D911','D920','D921','D930','D931','D940','D941',
'D902','D903','D912','D913','D922','D923','D932','D933','D942','D943',
'D904','D905','D914','D915','D924','D925','D934','D935','D944','D945',
'D908','D909','D918','D919','D928','D929','D938','D939','D948','D949',

'D1000','D1001','D1010','D1011','D1020','D1021','D1030','D1031','D1040','D1041',
'D1002','D1003','D1012','D1013','D1022','D1023','D1032','D1033','D1042','D1043',
'D1004','D1005','D1014','D1015','D1024','D1025','D1034','D1035','D1044','D1045',
'D1008','D1009','D1018','D1019','D1028','D1029','D1038','D1039','D1048','D1049',

'D1100','D1101','D1110','D1111','D1120','D1121','D1130','D1131','D1140','D1141',
'D1102','D1103','D1112','D1113','D1122','D1123','D1132','D1133','D1142','D1143',
'D1104','D1105','D1114','D1115','D1124','D1125','D1134','D1135','D1144','D1145',
'D1108','D1109','D1118','D1119','D1128','D1129','D1138','D1139','D1148','D1149',

'D1200','D1201','D1210','D1211','D1220','D1221','D1230','D1231','D1240','D1241',
'D1202','D1203','D1212','D1213','D1222','D1223','D1232','D1233','D1242','D1243',
'D1204','D1205','D1214','D1215','D1224','D1225','D1234','D1235','D1244','D1245',
'D1208','D1209','D1218','D1219','D1228','D1229','D1238','D1239','D1248','D1249'],

['D1406','D1407','D1416','D1417','D1426','D1427','D1436','D1437','D1446','D1447',

'D2500','D2501','D2510','D2511','D2520','D2521','D2530','D2531','D2540','D2541',
'D2502','D2503','D2512','D2513','D2522','D2523','D2532','D2533','D2542','D2543',
'D2504','D2505','D2514','D2515','D2524','D2525','D2534','D2535','D2544','D2545',
'D2508','D2509','D2518','D2519','D2528','D2529','D2538','D2539','D2548','D2549',

'D2600','D2601','D2610','D2611','D2620','D2621','D2630','D2631','D2640','D2641',
'D2602','D2603','D2612','D2613','D2622','D2623','D2632','D2633','D2642','D2643',
'D2604','D2605','D2614','D2615','D2624','D2625','D2634','D2635','D2644','D2645',
'D2608','D2609','D2618','D2619','D2628','D2629','D2638','D2639','D2648','D2649',

'D2700','D2701','D2710','D2711','D2720','D2721','D2730','D2731','D2740','D2741',
'D2702','D2703','D2712','D2713','D2722','D2723','D2732','D2733','D2742','D2743',
'D2704','D2705','D2714','D2715','D2724','D2725','D2734','D2735','D2744','D2745',
'D2708','D2709','D2718','D2719','D2728','D2729','D2738','D2739','D2748','D2749',

'D2800','D2801','D2810','D2811','D2820','D2821','D2830','D2831','D2840','D2841',
'D2802','D2803','D2812','D2813','D2822','D2823','D2832','D2833','D2842','D2843',
'D2804','D2805','D2814','D2815','D2824','D2825','D2834','D2835','D2844','D2845',
'D2808','D2809','D2818','D2819','D2828','D2829','D2838','D2839','D2848','D2849',

'D2900','D2901','D2910','D2911','D2920','D2921','D2930','D2931','D2940','D2941',
'D2902','D2903','D2912','D2913','D2922','D2923','D2932','D2933','D2942','D2943',
'D2904','D2905','D2914','D2915','D2924','D2925','D2934','D2935','D2944','D2945',
'D2908','D2909','D2918','D2919','D2928','D2929','D2938','D2939','D2948','D2949',

'D3000','D3001','D3010','D3011','D3020','D3021','D3030','D3031','D3040','D3041',
'D3002','D3003','D3012','D3013','D3022','D3023','D3032','D3033','D3042','D3043',
'D3004','D3005','D3014','D3015','D3024','D3025','D3034','D3035','D3044','D3045',
'D3008','D3009','D3018','D3019','D3028','D3029','D3038','D3039','D3048','D3049']]
            
        }
    },

    methods: {
        getMemory(idx){
       
            return this.datos_parrilla[this.parrilla-1][idx]
            
        },
        getValue: function (key) {
            return `${this.data[key]}`;
        }
    },
}
</script>
<style scoped>
     table {
            width: 100%;
            border-collapse: collapse;
        }
        th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: center;
        }
        th {
            background-color: #f2f2f2;
        }
        tr:nth-child(even) {
            background-color: #f9f9f9;
        }

        .table-container {
  overflow-y: auto;
}
.fixed-width{
    width: 15%;
}
        
</style>